import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { __t } from '@mssgme/shared';
import { ActionSheet } from '@mssgme/app/components/UI';
import { CardTopBranding } from '../CardTopBranding';
import { CardHeaderBackground } from '../CardHeaderBackground';
import { CardMessengersPane } from '../Messengers';
import { CardLinks } from '../CardLinks';
import { CardReviewsPaneContainer } from '../Reviews';
import { CardProductsContainer } from '../Products';
import styles from './styles.scss';

export class Card extends React.Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        className: PropTypes.string,
        widgetMode: PropTypes.bool,
        previewMode: PropTypes.bool,
        firstLoad: PropTypes.bool.isRequired,
        setFirstLoad: PropTypes.func.isRequired,
    };
    static defaultProps = {
        className: '',
        widgetMode: false,
        previewMode: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            animated: false,
            productsFetched: false,
            actionSheetVisible: false,
        };
        this.messengersPane = React.createRef();
    }

    toggleActionSheet = () => {
        this.setState((state) => ({
            actionSheetVisible: !state.actionSheetVisible,
        }));
    };

    componentDidMount() {
        this._isMounted = true;

        setTimeout(() => {
            if (this._isMounted) {
                this.setState({
                    animated: true,
                });
            }
        });

        const {
            previewMode,
            data: {
                profile: { fullname },
            },
        } = this.props;

        if (!previewMode) {
            const pageTitle = document.querySelector('title');
            pageTitle.innerText = fullname;
        }

        setTimeout(() => {
            this.props.setFirstLoad(false);
        }, 700);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { data, className, previewMode, widgetMode, firstLoad } = this.props;
        const { design, profile, messengers, links, reviews, workspaceId, collections, products, widget } = data;
        const { animated, actionSheetVisible } = this.state;
        const enabledLinks = links.filter((i) => i.enabled);
        const hasActionSheet = enabledLinks.length > 1;
        const hasProducts = collections.allPublishedProductsCount > 0;
        const productsVisible = hasProducts && !(widgetMode && !widget.components.products);

        return (
            <div
                className={classNames(styles.root, className)}
                id="cardRoot"
                style={{ pointerEvents: firstLoad ? 'none' : 'auto' }}
            >
                <div
                    className={styles.inner}
                    style={{
                        height: !design.branding ? '100%' : null,
                        top: !design.branding ? '0' : null,
                    }}
                >
                    {design.branding && <CardTopBranding animated={animated} />}
                    <div className={classNames(styles.background, styles.slideUp, animated ? styles.animated : null)}>
                        <CardHeaderBackground background={design.background} />
                        {/*{design.background.type === 'image' && design.background.image && (*/}
                        {/*    <CardHeaderBackground background={design.background}/>*/}
                        {/*)}*/}
                    </div>
                    <div className={styles.cardContent}>
                        <div ref={this.messengersPane}>
                            <CardMessengersPane
                                animated={animated}
                                photo={design.photoUrl}
                                fullName={profile.fullname}
                                category={profile.category}
                                messengers={messengers.filter((i) => i.enabled)}
                                description={profile.description}
                            />
                        </div>
                        {(!!links.find((i) => i.enabled) || !!profile.website.enabled) && (
                            <CardLinks
                                animated={animated}
                                links={links.filter((i) => i.enabled)}
                                website={profile.website}
                                showActionSheet={this.toggleActionSheet}
                            />
                        )}
                        {productsVisible && (
                            <CardProductsContainer
                                workspaceId={workspaceId}
                                collections={collections}
                                animated={animated}
                                userUrl={profile.url}
                                isAdmin={previewMode}
                                collectionsEnabled={products.collectionsEnabled}
                            />
                        )}
                        {reviews.enabled && (
                            <CardReviewsPaneContainer
                                workspaceId={workspaceId}
                                animated={animated}
                                fullName={profile.fullname}
                                previewMode={previewMode}
                            />
                        )}
                    </div>
                    {/*{design.branding && <CardBottomBranding animated={animated} />}*/}
                </div>
                {hasActionSheet && actionSheetVisible && (
                    <ActionSheet title={__t('menu_links')} links={enabledLinks} cancel={this.toggleActionSheet} />
                )}
            </div>
        );
    }
}
